import CoefCalculator from "components/tools/coef-calculator/CoefCalculator";
import InfoContext from "pages/InfoContext";
import { INFO_HEADER_NAVIGATION } from "constants/info-header";
import { useState, useEffect, useMemo, useCallback } from "react";
import {
  POPUP_STATUS,
  QUERY_STATUS,
  MANAGER_TOOLS_SECTIONS,
  FILTERS_FOR_NAMES,
  FILTER_KEYS,
} from "constants/constants";
import NavigationBar from "components/navigation-bar/NavigationBar";
import { useJobCategoryContext } from "api/settings/job-category/JobCategoryProvider";
import { useJobContext } from "api/settings/job/JobProvider";
import { useUserContext } from "api/user/UserProvider";
import { useSectorContext } from "api/settings/sector/SectorProvider";
import AbaqueToolsForm from "components/form/tools/abaque/AbaqueToolsForm";
import { useClientContext } from "api/directory/client/ClientProvider";
import MissionToolsForm from "components/form/tools/missions/MissionToolsForm";
import ClientsToolsForm from "components/form/tools/clients/ClientsToolsForm";
import CsltStrToolsForm from "components/form/tools/cslt-str/CsltStrToolsForm";
import ProspectionsToolsForm from "components/form/tools/prospections/ProspectionsToolsForm";
import FafWizard from "components/form/tools/faf/FafWizard";
import { canAccessFafTool } from "access-roles/general-functions";
import { usePersonContext } from "api/directory/person/PersonProvider";
import { useMissionContext } from "api/mission/MissionProvider";
import MissionsToolsByFilters from "components/form/tools/missions/MissionToolsByFilters";
import AbaqueToolsByFilters from "components/form/tools/abaque/AbaqueToolsByFilters";
import AlertPopup from "components/alert-popup/AlertPopup";
import ClientsToolsByFilter from "components/form/tools/clients/ClientsToolsByFilter";
import _ from "lodash";
import { ABAQUE_FORM_DEFAULT_VALUES } from "constants/forms";
import { useBranchesContext } from "api/settings/branches/BranchesProvider";
import { useCoefCalculatorContext } from "api/manager-tools/CoeffXCalculatorProvider";
import { useForm } from "react-hook-form";
import { useSalariesDatatrackContext } from "api/datatrack/salary/SalariesDatatrackProvider";
import { useProspectionContext } from "api/directory/prospection/ProspectionProvider";
import CsltStrByFilters from "components/form/tools/cslt-str/CsltStrByFilters";
import ProspectionsToolsByFilter from "components/form/tools/prospections/ProspectionsToolsByFilter";
import {
  EMPTY_SEARCH_FIELD_ERROR,
  ERROR_EDIT_MISSION_BILL,
  SUCCESS_ADD_PROSPECTION,
} from "constants/popup-codes";
import {
  cleanFiltersHelper,
  formatMissionData,
  getClientSlug,
  getDefaultToolsSection,
  getWorkerSlug,
  isValidFilters,
  jsonToQueryParams,
} from "utils/toolsManagerHelper";
import { getConsultantName, getWorkerProfile } from "utils/staffHelper";
import { getJobLabel, getStatusLabel } from "utils/workerHelper";
import { useGeneralContext } from "api/directory/general/GeneralProvider";
import { useLocalStorage } from "react-use";
import { Navigate, useParams } from "react-router-dom";
import ValidationModal from "components/modal/ValidationModal";
import { statusHandler } from "utils/helper";
import { isObjectFiltersEmpty } from "utils/sharedDashboardHelper";
import { getJobsInCategories } from "utils/functions";

const ToolsManager = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [clientsFilter, setClientsFilter] = useState("");
  const [csltStrFilter, setCsltStrFilter] = useState([]);
  const [code, setCode] = useState();
  const [status, setStatus] = useState();
  const [filters, setFilters] = useState({
    status: "status_one,status_ok,status_fdm",
  });
  const { fetchBranches, branches } = useBranchesContext();
  const { jobListGetter, jobList } = useJobContext();
  const {
    getCategoriesJobIds,
    getCategoryJobIds,
    jobCategoryList,
    jobCategoryListGetter,
  } = useJobCategoryContext();
  const {
    lang,
    setUserMissionsFilters,
    userScope,
    userRoleList,
    postUserFilters,
    getUserFilters,
    userFilterStorage,
  } = useUserContext();
  const sections = INFO_HEADER_NAVIGATION.tools;
  const { sectorListGetter, sectorList } = useSectorContext();
  const {
    getClientsBySearch,
    clientsBySearch,
    loadClientStatus,
    setClientsBySearch,
    setLoadClientStatus,
    askAssignmentById,
    askAssignmentStatus,
    setAskAssignmentStatus,
    setClientsByIds,
  } = useClientContext();
  const {
    createProspectionStatus,
    createProspection,
    setCreateProspectionStatus,
    errorData,
    getProspectionByClientAndProspectionIds,
    prospectionList,
    setProspectionList,
    getProspectionStatus,
    setGetProspectionStatus,
  } = useProspectionContext();
  const {
    control,
    formState: { errors },
    handleSubmit,
    register,
    setValue,
    watch,
    clearErrors,
  } = useForm({
    defaultValues: ABAQUE_FORM_DEFAULT_VALUES,
  });
  const { getPersonsByIds, personsList, setPersonsList, personById } =
    usePersonContext();
  const {
    getMissionsByFilters,
    missionsByFilters,
    setMissionsByFilters,
    loadMissionStatus,
    getMissionBySlug,
    setDisplayMission,
    setLoadMissionStatus,
    timelineMissionsList,
    setTimelineMissionsList,
    timelineQueryStatus,
    setTimelineQueryStatus,
    getTimeline,
    creationFileStatus,
  } = useMissionContext();
  const {
    statsHistorySalaryByBranches,
    getStatsHistorySalaryByBranchesExpDomain,
    setStatsHistorySalaryByBranches,
    getStatsHistorySalaryByPersonId,
    statsHistorySalaryByPersonIdStatus,
    statsHistorySalaryByBranchesStatus,
    setStatsHistorySalaryByBranchesStatus,
  } = useSalariesDatatrackContext();
  const { getCalculateCoefX, coefCalculatorResult } =
    useCoefCalculatorContext();
  const {
    searchGeneralByProfiles,
    usersByProfiles,
    getNamesByFilters,
    namesByFilters,
  } = useGeneralContext();
  const [missionTitle, setMissionTitle] = useLocalStorage(
    "tools_missions_mission-title-filter",
    []
  );
  const [missionsEndedAfterFilter, setMissionsEndedAfterFilter] =
    useLocalStorage("tools_missions_missions-ended-after-filter", "");

  const [missionJob, setMissionJob] = useLocalStorage(
    "tools_missions_mission-job-filter",
    []
  );
  const [missionJobCategory, setMissionJobCategory] = useLocalStorage(
    "tools_missions_mission-job-category-filter",
    []
  );
  const [missionClientSector, setMissionClientSector] = useLocalStorage(
    "tools_missions_mission-sector-filter",
    []
  );
  const [missionStatusfilter, setMissionStatusfilter] = useLocalStorage(
    "tools_missions_mission-status-filter",
    []
  );
  const [isMissionsStarOnly, setIsMissionsStarOnly] = useLocalStorage(
    "tools_missions_mission-star-only-filter",
    false
  );
  const [isMissionsImpactOnly, setIsMissionsImpactOnly] = useLocalStorage(
    "tools_missions_mission-impact-only-filter",
    false
  );

  const [prospectionValue, setProspectionValue] = useLocalStorage(
    "tools-prospections_client-filter",
    []
  );
  const [clientsMissionsStatusFilter, setClientsMissionsStatusFilter] =
    useLocalStorage("tools-clients_status-filter", []);
  const [missionTitleFilter, setMissionTitleFilter] = useState(
    missionTitle || []
  );
  const [dateFilter, setDateFilter] = useState(missionsEndedAfterFilter || "");
  const [sectorFilter, setSectorFilter] = useState(missionClientSector || []);
  const [jobFilter, setJobFilter] = useState(missionJob || []);
  const [jobCategoryFilter, setJobCategoryFilter] = useState(
    missionJobCategory || []
  );

  const [selectedMission, setSelectedMission] = useState(null);
  const [modal, setModal] = useState(false);
  const [setSlug] = useState("");
  const [searchClient, setSearchClient] = useState("");
  const [clientsMissionsStatus, setClientsMissionsStatus] = useState(
    clientsMissionsStatusFilter || []
  );
  const [missionStatus, setMissionStatus] = useState(missionStatusfilter || []);
  const btnColor = {
    default: "gray-200",
    isStar: "gamboge",
    isImpact: "green",
  };
  const [star, setStar] = useState({
    isStar: isMissionsStarOnly,
    color: btnColor.default,
  });
  const [impact, setImpact] = useState({
    isImpact: isMissionsImpactOnly,
    color: btnColor.default,
  });
  const [prospectionFilter, setProspectionFilter] = useState(
    prospectionValue || []
  );
  const [validationModalMessage, setValidationModalMessage] = useState({});
  const { tab } = useParams();
  const [section, setSection] = useState(
    () => tab ?? getDefaultToolsSection({ sections, userRoleList })
  );

  const sortedSectorList = useMemo(
    () => [
      { id: 0, fr: "Tous", en: "All" },
      ...[...sectorList].sort((a, b) =>
        (a[lang] || "").localeCompare(b[lang] || "")
      ),
    ],
    [sectorList, lang]
  );

  const workersList = namesByFilters?.filter(
    (e) => e.type === FILTERS_FOR_NAMES.PERSON
  );

  const clientsList = namesByFilters?.filter(
    (e) => e.type === FILTERS_FOR_NAMES.CLIENT
  );

  const onError = () => {
    setStatus(POPUP_STATUS.ERROR);
    setCode(EMPTY_SEARCH_FIELD_ERROR);
  };

  const [filterAbaque, setFilterAbaque] = useLocalStorage(
    "tools_manager_abaque_filters",
    {
      experience: null,
      branch_id: [],
      domain_category_id: [],
      domain_id: [],
    }
  );

  const setFiltersPriority = (key, setFilter, dbFilters) => {
    const storedValue = localStorage.getItem(key);
    if (storedValue) {
      const parsed = JSON.parse(storedValue);
      if (isObjectFiltersEmpty(parsed)) {
        if (!isObjectFiltersEmpty(dbFilters)) {
          setFilter(dbFilters);
          localStorage.setItem(key, JSON.stringify(dbFilters));
        } else {
          setFilter({});
        }
      } else {
        setFilter(parsed);
      }
    } else {
      if (!isObjectFiltersEmpty(dbFilters)) {
        setFilter(dbFilters);
        localStorage.setItem(key, JSON.stringify(dbFilters));
      } else {
        setFilter({});
      }
    }
  };

  // Fetch abaque filters from DB on mount
  useEffect(() => {
    getUserFilters(FILTER_KEYS.TOOLS_MANAGER);
  }, []);

  // When DB response arrives, arbitrate between localStorage and DB
  // Guard: only process if userFilterStorage has tools_manager shape (not shared_dashboard data)
  useEffect(() => {
    if (
      !userFilterStorage?.experience &&
      !userFilterStorage?.branch_id &&
      !userFilterStorage?.domain_category_id &&
      !userFilterStorage?.domain_id
    )
      return;
    setFiltersPriority(
      "tools_manager_abaque_filters",
      setFilterAbaque,
      userFilterStorage
    );
  }, [userFilterStorage]);

  // Restore form values from filterAbaque (localStorage state).
  //
  // A job only comes back with a category that offers it (redmine 12939). A
  // stored pair can be incoherent two ways: it predates the feature, when the
  // category was optional, or the user just removed a category — this effect
  // runs after the form pruned itself, and re-applying the stored list would
  // undo that prune. Either way the job field is locked or narrowed, so the
  // filter would be applied to every search with no way to remove it by hand.
  useEffect(() => {
    if (filterAbaque.experience)
      setValue("experience", filterAbaque.experience);
    if (filterAbaque.branch_id?.length)
      setValue("branch_id", filterAbaque.branch_id);
    const categories = filterAbaque.domain_category_id || [];
    if (categories.length) setValue("domain_category_id", categories);

    const storedJobs = filterAbaque.domain_id || [];
    if (!storedJobs.length) return;
    if (!categories.length) {
      setValue("domain_id", []);
      return;
    }
    // The referential lands after the stored filters; an empty one would read
    // as "these categories offer nothing" and wipe a legitimate pair.
    if (!jobCategoryList?.length) {
      setValue("domain_id", storedJobs);
      return;
    }
    const kept = getJobsInCategories(
      storedJobs,
      getCategoriesJobIds(categories.map((elm) => elm?.value).filter(Boolean))
    );
    setValue(
      "domain_id",
      kept.length === storedJobs.length ? storedJobs : kept
    );
  }, [filterAbaque, jobCategoryList]);

  // The provider swallows search errors: surface them instead of a silent 400
  useEffect(() => {
    if (loadMissionStatus !== QUERY_STATUS.ERROR) return;
    setStatus(POPUP_STATUS.ERROR);
    setCode(ERROR_EDIT_MISSION_BILL);
  }, [loadMissionStatus]);

  // Persist abaque form values to localStorage on every input change
  useEffect(() => {
    const subscription = watch((formValues) => {
      const { experience, branch_id, domain_category_id, domain_id } =
        formValues;
      if (
        !experience &&
        !branch_id?.length &&
        !domain_category_id?.length &&
        !domain_id?.length
      )
        return;
      const newFilters = {
        experience,
        branch_id,
        domain_category_id,
        domain_id,
      };
      const current = localStorage.getItem("tools_manager_abaque_filters");
      if (current === JSON.stringify(newFilters)) return;
      setFilterAbaque(newFilters);
    });
    return () => subscription.unsubscribe();
  }, [watch]);

  useEffect(
    () => () => {
      setLoadMissionStatus(QUERY_STATUS.INITIAL);
      setMissionsByFilters({});
      setMissionTitle([]);
      setMissionsEndedAfterFilter("");
      setDateFilter("");
      setMissionTitleFilter([]);
      setMissionJob([]);
      setJobFilter([]);
      setMissionJobCategory([]);
      setJobCategoryFilter([]);
      setSectorFilter([]);
      setMissionClientSector([]);
      setMissionStatusfilter([]);
      setMissionStatus([]);
      setStar({ isStar: false, color: btnColor.default });
      setIsMissionsStarOnly(false);
      setImpact({ isImpact: false, color: btnColor.default });
      setIsMissionsImpactOnly(false);
      setLoadClientStatus(QUERY_STATUS.INITIAL);
      setClientsBySearch({});
      setGetProspectionStatus(QUERY_STATUS.INITIAL);
      setProspectionList({});
      setProspectionValue([]);
      setClientsMissionsStatusFilter([]);
      setProspectionFilter([]);
      setStatsHistorySalaryByBranches([]);
      setStatsHistorySalaryByBranchesStatus(QUERY_STATUS.INITIAL);
      setDisplayMission(false);
      setPersonsList([]);
      setClientsByIds([]);
    },
    []
  );

  const searchCsltStrTimelineMissions = () => {
    if (csltStrFilter?.length > 0) {
      getTimeline({
        filters: { type: "cslt_str", id: csltStrFilter[0].value },
        isToolsManager: true,
      });
    } else {
      onError();
    }
  };

  useEffect(() => {
    setTimelineMissionsList([]);
    setTimelineQueryStatus(QUERY_STATUS.INITIAL);
  }, [csltStrFilter]);

  useEffect(() => {
    if (createProspectionStatus === QUERY_STATUS.SUCCESS) {
      setStatus(POPUP_STATUS.SUCCESS);
      setCode(SUCCESS_ADD_PROSPECTION);
      setCreateProspectionStatus(QUERY_STATUS.INITIAL);
    }
  }, [createProspectionStatus]);

  const user_id = personById?.id;

  const getMission = ({ slug }) => {
    setSlug(slug);
    slug && getMissionBySlug({ slug });
    return setDisplayMission(true);
  };

  const searchMissionsWithFilters = ({ filters, orderBy }) => {
    const cleanFilters = cleanFiltersHelper(filters);
    if (isValidFilters({ filters: cleanFilters, setStatus, setCode })) {
      setUserMissionsFilters(cleanFilters);
      setFilters(cleanFilters);
      getMissionsByFilters({
        page: 1,
        filters: jsonToQueryParams(cleanFilters),
        orderBy,
      });
      setDisplayMission(false);
    }
  };

  const getMoreMissions = ({ page, orderBy }) => {
    const cleanFilters = cleanFiltersHelper(filters);
    getMissionsByFilters({
      page,
      filters: jsonToQueryParams(cleanFilters),
      orderBy,
    });
  };

  useEffect(() => {
    jobListGetter();
    jobCategoryListGetter();
    sectorListGetter();
    fetchBranches();
  }, []);

  const renderToolsForm = () => {
    switch (section) {
      case MANAGER_TOOLS_SECTIONS.missions:
        return (
          <MissionToolsForm
            setDisplayMission={setDisplayMission}
            lang={lang}
            jobList={jobList}
            sectorList={sortedSectorList}
            getFilters={searchMissionsWithFilters}
          />
        );
      case MANAGER_TOOLS_SECTIONS.clients:
        return (
          <ClientsToolsForm
            search={(search) => {
              setClientsBySearch({});
              setSearchClient(search);
              getClientsBySearch({
                page: 1,
                search,
                status: clientsMissionsStatus,
              });
            }}
          />
        );
      case MANAGER_TOOLS_SECTIONS.consultants_subcontractors:
        return (
          <CsltStrToolsForm
            searchGeneralByProfiles={searchGeneralByProfiles}
            usersByProfiles={usersByProfiles}
            searchCsltStrTimelineMissions={searchCsltStrTimelineMissions}
            getNamesByFilters={getNamesByFilters}
            namesByFilters={namesByFilters}
          />
        );
      case MANAGER_TOOLS_SECTIONS.prospections:
        return <ProspectionsToolsForm />;
      case MANAGER_TOOLS_SECTIONS.faf:
        // Role guard: the switch renders even on direct URL access, so we
        // re-check the F&F access here (NavigationBar only hides the button).
        return canAccessFafTool(userRoleList) ? (
          <FafWizard />
        ) : null;
      case MANAGER_TOOLS_SECTIONS.abaque:
        return (
          <AbaqueToolsForm
            jobList={jobList}
            branches={branches}
            setStatsHistorySalaryByBranches={setStatsHistorySalaryByBranches}
          />
        );
      default:
        return null;
    }
  };

  const closeModal = () => {
    setModal(false);
  };

  // Categories narrow the search themselves when no job was picked: the abaque
  // endpoint only knows jobs, so their jobs are sent in their stead.
  const getAbaqueDomainIds = (filter) =>
    filter?.domain_id?.length
      ? filter.domain_id
      : getCategoriesJobIds(filter?.domain_category_id);

  const getAbaqueFilters = (filter) => {
    statsHistorySalaryByBranchesStatus !== QUERY_STATUS.LOADING &&
      getStatsHistorySalaryByBranchesExpDomain({
        experience: filter?.experience,
        domain_ids: getAbaqueDomainIds(filter),
        branch_ids: filter?.branch_id,
      });
    // Persist abaque filters to DB
    const abaqueFilters = {
      experience: watch("experience"),
      branch_id: watch("branch_id"),
      domain_category_id: watch("domain_category_id"),
      domain_id: watch("domain_id"),
    };
    postUserFilters(
      { key: FILTER_KEYS.TOOLS_MANAGER, value: JSON.stringify(abaqueFilters) },
      FILTER_KEYS.TOOLS_MANAGER
    );
  };

  const getStatsSalaries = (id, branch_id, experience) => {
    statsHistorySalaryByPersonIdStatus !== QUERY_STATUS.LOADING &&
      getStatsHistorySalaryByPersonId({
        id: id,
        branch_id: branch_id,
        experience: experience,
      });
  };

  const getMoreClients = ({ page, filters }) =>
    getClientsBySearch({
      page,
      search: searchClient,
      status: clientsMissionsStatus,
      filters: _.omitBy(filters, _.isEmpty),
    });

  const idsParamHandler = ({ prospectionFilter, idsType }) =>
    prospectionFilter
      .filter((e) => e.type === idsType)
      .map((e) => e.value)
      .join(",");

  const handleGetProspectionsSubmit = useCallback(() => {
    if (prospectionFilter?.length > 0) {
      getProspectionByClientAndProspectionIds({
        client_ids: idsParamHandler({
          prospectionFilter,
          idsType: "clients",
        }),
        prospection_ids: idsParamHandler({
          prospectionFilter,
          idsType: "prospections",
        }),
      });
      setProspectionValue(prospectionFilter);
    }
  }, [
    getProspectionByClientAndProspectionIds,
    prospectionFilter,
    setProspectionValue,
  ]);

  useEffect(() => {
    if (askAssignmentStatus === QUERY_STATUS.SUCCESS) {
      setIsOpen(true);
      setAskAssignmentStatus(QUERY_STATUS.INITIAL);
    }
  }, [askAssignmentStatus, setAskAssignmentStatus]);

  useEffect(() => {
    if (clientsBySearch?.content?.length > 0) {
      const idWorkers = _.chain(clientsBySearch?.content)
        .map("mission_worker_id")
        .uniq()
        .filter((elm) => !_.chain(personsList).map("id").includes(elm).value())
        .value();
      const idManagers = _.chain(clientsBySearch?.content)
        .map("mission_manager_id")
        .uniq()
        .filter((elm) => !_.chain(personsList).map("id").includes(elm).value())
        .value();
      getPersonsByIds({
        ids: _.chain(idWorkers).concat(idManagers).uniq().join(",").value(),
      });
    }
  }, [clientsBySearch, userScope]);

  const openMissionModal = (missionData) => {
    setSelectedMission(
      formatMissionData({
        data: missionData,
        getConsultantName,
        lang,
        jobList,
        workersList,
        clientsList,
      })
    );
    setModal(true);
  };

  const propsObject = {
    getClientSlug,
    getWorkerSlug,
    jobList,
    jobCategoryList,
    getWorkerProfile,
    getJobLabel,
    lang,
    getStatusLabel,
    userScope,
    openMissionModal,
    namesByFilters,
    creationFileStatus,
  };

  const values = useMemo(
    () => ({
      csltStrFilter,
      setCsltStrFilter,
      lang,
      sections,
      setSection,
      closeModal,
      setCode,
      setStatus,
      getAbaqueFilters,
      getStatsSalaries,
      control,
      errors,
      handleSubmit,
      register,
      setValue,
      watch,
      clearErrors,
      getCalculateCoefX,
      coefCalculatorResult,
      setUserMissionsFilters,
      missionsByFilters,
      clientsFilter,
      setClientsFilter,
      addNewProspection: createProspection,
      user_id,
      createProspectionStatus,
      errorData,
      timelineQueryStatus,
      getProspectionStatus,
      getNamesByFilters,
      namesByFilters,
      askAssignmentById,
      createProspection,
      prospectionList,
      userScope,
      prospectionValue,
      prospectionFilter,
      setProspectionFilter,
      missionTitle,
      setMissionTitle,
      missionJob,
      setMissionJob,
      setMissionJobCategory,
      missionClientSector,
      setMissionClientSector,
      missionStatusfilter,
      setMissionStatusfilter,
      isMissionsStarOnly,
      setIsMissionsStarOnly,
      setIsMissionsImpactOnly,
      missionTitleFilter,
      setMissionTitleFilter,
      jobFilter,
      jobCategoryFilter,
      setJobCategoryFilter,
      jobCategoryList,
      getCategoriesJobIds,
      getCategoryJobIds,
      setJobFilter,
      sectorFilter,
      setSectorFilter,
      missionStatus,
      setMissionStatus,
      star,
      setStar,
      impact,
      setImpact,
      handleGetProspectionsSubmit,
      setValidationModalMessage,
      btnColor,
      clientsMissionsStatus,
      setClientsMissionsStatus,
      setClientsMissionsStatusFilter,
      setMissionsByFilters,
      isToolsManager: true,
      activeSection: section,
      missionsEndedAfterFilter,
      setMissionsEndedAfterFilter,
      dateFilter,
      setDateFilter,
    }),
    [
      csltStrFilter,
      setCsltStrFilter,
      lang,
      sections,
      setSection,
      closeModal,
      setCode,
      setStatus,
      getAbaqueFilters,
      getStatsSalaries,
      control,
      errors,
      handleSubmit,
      register,
      setValue,
      watch,
      clearErrors,
      getCalculateCoefX,
      coefCalculatorResult,
      setUserMissionsFilters,
      missionsByFilters,
      clientsFilter,
      setClientsFilter,
      createProspection,
      user_id,
      createProspectionStatus,
      errorData,
      timelineQueryStatus,
      getProspectionStatus,
      getNamesByFilters,
      namesByFilters,
      askAssignmentById,
      prospectionList,
      userScope,
      prospectionValue,
      prospectionFilter,
      setProspectionFilter,
      missionTitle,
      setMissionTitle,
      missionJob,
      setMissionJob,
      setMissionJobCategory,
      missionClientSector,
      setMissionClientSector,
      missionStatusfilter,
      setMissionStatusfilter,
      isMissionsStarOnly,
      setIsMissionsStarOnly,
      setIsMissionsImpactOnly,
      missionTitleFilter,
      setMissionTitleFilter,
      jobFilter,
      jobCategoryFilter,
      setJobCategoryFilter,
      jobCategoryList,
      getCategoriesJobIds,
      getCategoryJobIds,
      setJobFilter,
      sectorFilter,
      setSectorFilter,
      missionStatus,
      setMissionStatus,
      star,
      setStar,
      impact,
      handleGetProspectionsSubmit,
      setValidationModalMessage,
      clientsMissionsStatus,
      setClientsMissionsStatusFilter,
      missionsEndedAfterFilter,
      setMissionsEndedAfterFilter,
      dateFilter,
      setDateFilter,
    ]
  );

  // Menu and post-login entries land on the tab-less URL: write the default
  // tab into it. Same route element, so the page stays mounted and keeps its
  // state, and the navigation bar never renders without a tab in the URL. The
  // default is recomputed here: `section` still holds the tab the user was on
  // when the header entry is clicked from inside the page.
  if (!tab) {
    return (
      <Navigate
        to={getDefaultToolsSection({ sections, userRoleList })}
        replace
      />
    );
  }

  return (
    <InfoContext.Provider value={values}>
      <AlertPopup
        code={code}
        setCode={setCode}
        setStatus={setStatus}
        status={status}
      />
      <ValidationModal
        status={statusHandler({
          statusList: [
            askAssignmentStatus,
            createProspectionStatus,
            getProspectionStatus,
          ],
        })}
        open={isOpen}
        onClose={() => {
          setIsOpen(false);
          handleGetProspectionsSubmit();
        }}
        messages={validationModalMessage}
      />
      <div style={{ paddingTop: "4rem" }}>
        <CoefCalculator />
        <NavigationBar />
        {renderToolsForm()}
        {section === MANAGER_TOOLS_SECTIONS.missions && (
          <MissionsToolsByFilters
            selectedMission={selectedMission}
            searchMissionsWithFilters={searchMissionsWithFilters}
            userScope={userScope}
            getMoreMissions={getMoreMissions}
            loadMissionStatus={loadMissionStatus}
            getMission={getMission}
            propsObject={propsObject}
            modal={modal}
            filters={filters}
            setModal={setModal}
            workersList={workersList}
            clientsList={clientsList}
          />
        )}
        {section === MANAGER_TOOLS_SECTIONS.clients && (
          <ClientsToolsByFilter
            clientsBySearch={clientsBySearch}
            loadClientStatus={loadClientStatus}
            getMoreClients={getMoreClients}
            personsList={personsList}
            filters={clientsFilter}
            lang={lang}
          />
        )}
        {section === MANAGER_TOOLS_SECTIONS.consultants_subcontractors && (
          <CsltStrByFilters
            missionsList={timelineMissionsList}
            getTimeline={getTimeline}
            filters={csltStrFilter}
          />
        )}
        {section === MANAGER_TOOLS_SECTIONS.prospections && (
          <ProspectionsToolsByFilter />
        )}
        {section === MANAGER_TOOLS_SECTIONS.abaque && (
          <AbaqueToolsByFilters
            statsHistorySalaryByBranches={statsHistorySalaryByBranches}
            statsHistorySalaryByBranchesStatus={
              statsHistorySalaryByBranchesStatus
            }
          />
        )}
      </div>
    </InfoContext.Provider>
  );
};

export default ToolsManager;
